import React from 'react';
import PropTypes from 'prop-types';
import TickBox from '../Icons/Tick-Box.svg';
import TickBoxDisabled from '../Icons/Tick-Box-Unselected-Disabled.svg';

import TickBoxActive from '../Icons/Tick-Box-Active.svg';
import TickBoxActiveDisabled from '../Icons/Tick-Box-Active-Read-Only.svg';

import TickBoxIndeterminate from '../Icons/Tick-Box-Indeterminate.svg';
import TickBoxIndeterminateDisabled from '../Icons/Tick-Box-Indeterminate-Read-Only.svg';
import defaultStyles from './Checkbox.module.scss';

export const checkboxStates = {
    checked: true,
    unchecked: false,
    indeterminate: 'CHECKBOX_STATE/INDETERMINATE'
};

const iconMap = {
    [true]: {
        [checkboxStates.checked]: TickBoxActive,
        [checkboxStates.unchecked]: TickBox,
        [checkboxStates.indeterminate]: TickBoxIndeterminate
    },
    [false]: {
        [checkboxStates.checked]: TickBoxActiveDisabled,
        [checkboxStates.unchecked]: TickBoxDisabled,
        [checkboxStates.indeterminate]: TickBoxIndeterminateDisabled
    }
};

const Checkbox = (props) => (
    <button
        className={ props.styles.checkbox }
        onClick={ (e) => {
            e.stopPropagation();
            props.onChange(!props.checked);
        } }
        type="button"
        disabled={ props.disabled }
    >
        <img src={ iconMap[!props.disabled][props.checked] } alt="" />
    </button>
);

Checkbox.propTypes = {
    checked: PropTypes.oneOf(Object.values(checkboxStates)),
    onChange: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string),
    disabled: PropTypes.bool
};

Checkbox.defaultProps = {
    checked: false,
    styles: defaultStyles,
    disabled: false
};

export default Checkbox;
